import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { Customer } from '../../../interfaces/customer.model';

@Component({
  selector: 'app-personal-details',
  imports: [CommonModule],
  templateUrl: './personal-details.component.html',
  styleUrls: ['./personal-details.component.scss'],
})
export class PersonalDetailsComponent {
  customer = input.required<Customer>();
  dobError = input<boolean>(false);
  genderValue = input<string>('n/a');
  smokerValue = input<string>('n/a');
}
